export enum EReducersPath {
  BASE_API = 'baseApi',
  BANKING_API = 'bankingApi',
  CORE_API = 'coreApi',
  USERS_API = 'usersApi',
  SIMPLE_API = 'simpleApi',
  CHORES_API = 'choresApi',
  WEB3_API = 'web3Api',
  GIPHY_API = 'giphyApi',
  WEBFLOW_API = 'webflowApi',
  CARDS_API = 'cardsApi',
  ADD_KID_API = 'addKidApi',
  CARDS_THEME_API = 'cardsThemeApi',
  KYC_API = 'kycApi',
  PAYMENT_LINK_API = 'paymentLinkApi',
  PAYMENT_LINK_V2_API = 'paymentLinkApiV2',
  SPLIT_BILLS_API = 'splitBillsApi',
  SPLITS_API = 'splitsApi',
  SPLIT_BILLS_GROUPS_API = 'splitBillsGroupsApi',
  EDIT_INFO_API = 'editInfoApi',
}
